import { Injectable, computed, signal } from '@angular/core';
import { VoiceFlowContext, VoiceFlowContextSnapshot } from './voice-flow.models';

@Injectable({
  providedIn: 'root'
})
export class VoiceFlowContextService {
  private readonly contexts = signal<Record<string, VoiceFlowContext>>({});

  readonly allContexts = computed(() => Object.values(this.contexts()));

  register(context: VoiceFlowContext): void {
    this.contexts.update((current) => ({
      ...current,
      [context.flowId]: context
    }));
  }

  unregister(flowId: string): void {
    this.contexts.update((current) => {
      const { [flowId]: _, ...remaining } = current;
      return remaining;
    });
  }

  snapshotForRoute(routePath: string): VoiceFlowContextSnapshot {
    const flows = this.allContexts()
      .filter((flow) => flow.routePath === '*' || flow.routePath === routePath)
      .map((flow) => {
        const itemLimit = flow.routePath === '*' ? 80 : 12;
        return {
          ...flow,
          items: (flow.items || []).slice(0, itemLimit)
        };
      });

    return {
      activeRoutePath: routePath,
      flows
    };
  }
}
